import { useEffect, useState } from "react";
import { Briefcase } from "lucide-react";
import api from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

let cache = null;
const listeners = new Set();

export function invalidateCommittenti() { cache = null; listeners.forEach((fn) => fn()); }

export function useCommittenti() {
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    const load = () => { if (cache) return setList(cache); api.get("/committenti").then(({ data }) => { cache = data; setList(data); }).catch(() => {}); };
    load();
    listeners.add(load);
    return () => listeners.delete(load);
  }, []);
  return list;
}

const NONE = "__none__";

export function committenteStyle(color) {
  if (!color) return null;
  const n = parseInt(color.slice(1), 16);
  const lum = (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  return { background: color, color: lum > 0.6 ? "#1e293b" : "#ffffff", borderColor: color };
}

export function useCommittenteColor(name) {
  const list = useCommittenti();
  return list.find((c) => c.name === name)?.color || null;
}

function Dot({ color }) {
  return <span className="w-2.5 h-2.5 rounded-full shrink-0 border border-black/10" style={{ background: color || "#e2e8f0" }} />;
}

export default function CommittenteSelect({ value, onChange, testid = "committente-select", mode = "form", className = "" }) {
  const list = useCommittenti();
  const isFilter = mode === "filter";
  const current = value || (isFilter ? "all" : NONE);
  const options = list.filter((c) => c.active || c.name === value);
  return (
    <Select value={current} onValueChange={(v) => onChange(isFilter ? v : (v === NONE ? "" : v))}>
      <SelectTrigger data-testid={testid} className={`${isFilter ? "w-full sm:w-52 h-10 bg-white" : ""} ${className}`}>
        <span className="flex items-center gap-2 truncate"><Briefcase className="w-3.5 h-3.5 text-slate-400 shrink-0" /><SelectValue placeholder={isFilter ? "Committente" : "Seleziona committente"} /></span>
      </SelectTrigger>
      <SelectContent>
        {isFilter ? <SelectItem value="all">Committente: Tutti</SelectItem> : <SelectItem value={NONE}>— Nessuno —</SelectItem>}
        {options.map((c) => <SelectItem key={c.id} value={c.name} data-testid={`${testid}-option-${c.id}`}><span className="inline-flex items-center gap-2"><Dot color={c.color} />{c.name}</span></SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function CommittenteBadge({ value, testid }) {
  const color = useCommittenteColor(value);
  if (!value) return null;
  const st = committenteStyle(color);
  return (
    <span data-testid={testid} style={st || undefined}
      className={`inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${st ? "" : "bg-amber-50 border-amber-200 text-amber-800"}`}>
      <Briefcase className="w-3 h-3" />{value}
    </span>
  );
}
